{
  "title": "Kişisel profil",
  "info": "Kişisel bilgiler",
  "idCopy": "ID'mi kopyala",
  "copied": "ID kopyalandı",
  "copyFailed": "ID kopyalanamadı",
  "name": "Ad",
  "surname": "Soyad",
  "birth": "Doğum tarihi",
  "gender": "Cinsiyet",
  "chooseGender": "Cinsiyet seçin",
  "male": "Erkek",
  "female": "Kadın",
  "save": "Kaydet",
  "saved": "Profil kaydedildi",
  "missing": "Lütfen tüm kişisel bilgileri doldurun.",
  "failed": "Profil kaydedilemedi.",
  "alreadySaved": "Kişisel bilgiler onaylandı ve kilitlendi.",
  "confirmTitle": "İşleminizi onaylayın",
  "confirmText": "Bilgilerinizin doğru olduğunu onaylayın. Onaydan sonra değişiklikler yönetici onayı gerektirir.",
  "verify": "Onayla",
  "back": "Geri",
  "contacts": "İletişim bilgileri",
  "linked": "Bağlı",
  "notLinked": "Bağlı değil",
  "unverified": "Doğrulanmamış",
  "manage": "Yönet",
  "telegram": "Telegram",
  "unavailable": "Kullanılamıyor",
  "phone": "Telefon numarası",
  "email": "E-posta",
  "change": "Değişiklik talep et",
  "pending": "Değişiklik talebiniz beklemede.",
  "requestTitle": "Kişisel bilgileri değiştir",
  "changeHelp": "Değişiklikler için yönetici onayı gerekir.",
  "reason": "Değişiklik nedeni",
  "submit": "Talebi gönder",
  "noChanges": "Talep edilen değişiklik yok.",
  "changeFailed": "Talep başarısız oldu.",
  "changeSent": "Talep yöneticiye iletildi.",
  "support": "Destek ile iletişim",
  "age": "Doğru bir doğum tarihi girin.",
  "loggingOut": "Çıkış yapılıyor...",
  "logout": "Çıkış yap"
}
